import { css } from 'styled-components';

import { colorUsage, fontSize, letterSpacing } from 'stylesheetB2c';

import { ColorPalette } from './colorPalette';

const getColorStyle = (secondary: boolean, light: boolean) => {
  const colorPalette =
    colorUsage.bamOnline.CTA[secondary ? ColorPalette.SECONDARY : ColorPalette.PRIMARY];

  return light
    ? css`
        border: 1px solid ${colorPalette.accent};
        color: ${colorPalette.accent};
        background-color: ${colorPalette.soft};
      `
    : css`
        border: 1px solid ${colorPalette.accent};
        color: ${colorPalette.soft};
        background-color: ${colorPalette.accent};
        :hover {
          background-color: ${colorPalette.hover};
        }
      `;
};

export const primaryCTAColorStyle = getColorStyle(false, false);

export const getBamOnlineCTAStyle = (secondary: boolean, light: boolean) => css`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${fontSize.small};
  letter-spacing: ${letterSpacing.small};
  cursor: pointer;
  text-decoration: none;

  /* Using a hack to always have circle border radius : https://www.w3.org/TR/css-backgrounds-3/#corner-overlap */
  border-radius: 999px;
  ${getColorStyle(secondary, light)}
`;
